<template>
  <div class="core_tech_wrap">
    <div class="title_container">
      <div class="title_box">
        <div class="title_1">CORE TECHNOLOGIES</div>
        <div class="title_2">核心技术</div>
        <div class="title_3"/>
      </div>
    </div>
    <!-- 轮播部分 -->
    <CarouseCard :items="coreTechData" :interval="9000"></CarouseCard>
  </div>
</template>

<script>
  import CarouseCard from '@/components/carousel/CarouseCard.vue'
  export default {
    name: "CoreTechMod",
    props: {
      coreTechData: {
        type: Array,
        default: () => {
          return []
        }
      }
    },
    components: { CarouseCard },
    data () {
      return {}
    },
  }
</script>

<style scoped lang="scss">
.core_tech_wrap {
  width: 100%;
  padding-top: 5%;
  padding-bottom: 5%;
}
.title_container {
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  width: 94%;
  max-width: 1320px;
  margin: 0 auto;
  .title_box {
    flex: 1 1 0;
    display: flex;
    flex-direction: column;
    max-width: 100%;
    max-height: 100%;
    .title_1 {
      line-height: normal;
      font-size: 60px;
      color: rgb(245, 245, 245);
      text-align: center;
      font-weight: bold;
      @media screen and (max-width: 768px) {
        font-size: 30px;
      }
    }
    .title_2 {
      line-height: normal;
      font-size: 30px;
      font-weight: normal;
      color: rgb(5, 85, 182);
      text-align: center;
      margin-top: -30px;
      @media screen and (max-width: 768px) {
        font-size: 24px;
        margin-top: -20px;
      }
    }
    .title_3 {
      border-top-style: solid;
      border-top-width: 2px;
      border-top-color: rgb(5, 85, 182);
      width: 56px;
      margin: 16px auto 30px auto;
      @media screen and (max-width: 768px) {
        margin: 10px auto 20px auto;
      }
    }
  }
}

</style>
